import "./block/shipping/index.js";
import "./block/popover/index.js";

document.addEventListener( 'DOMContentLoaded', function() {
    // setup our gallery sliders
    const galleries = document.getElementsByClassName('product-grid_gallery');
    for ( const gallery of galleries ) {
        const slideCount = gallery.querySelectorAll('.splide__slide').length;
        new window.Splide( gallery, { arrows: slideCount > 1 } ).mount()
    }

    const atc_collection = document.getElementsByClassName('product-grid_atc');
    for( details of atc_collection ) {
        details.addEventListener('qtychange', 
            (event) => {
                const details = event.currentTarget
                const summary = details.querySelector('summary')
                const cart_item = details.querySelector('.--in-cart');
                if ( cart_item ) {
                    details.open = true
                    summary.inert = true
                } else {
                    summary.inert = false
                }
            }
        );
    }

} );

// setup product qty controls
jQuery(document).ready(function($){
    function handlePending(qty, details, input, live, cart_qty_input, legend) {
        // update minicart
        const sidebar_items = document.querySelectorAll('.product-grid_minicart, .product-grid_shipping');
        for( const sidebar_item of sidebar_items ) {
            sidebar_item.inert = true;
        }
        const summary_label = details?.querySelector('.product-grid_atc-label');
        input.classList.add('--pending');
        if ( qty ) {
            const change_value = qty - (cart_qty_input.value ?? 0);
            if ( 0 < change_value ) {
                live.textContent = `Adding ${change_value} ${legend.textContent} to cart`;
                if (summary_label) {
                    summary_label.textContent = 'Updating Order';
                }
            } else {
                live.textContent = `Removing ${Math.abs(change_value)} ${legend.textContent} from cart`;
                if (summary_label) {
                    summary_label.textContent = 'Updating Order';
                }
            }
        } else {
            live.textContent = `Removing ${legend.textContent} from cart`;
            if (summary_label) {
                summary_label.textContent = 'Updating Order';
            }
        }
    }

    function handleResponse(qty, response, details, input, live, cart_qty_input, legend) {
        const summary_label = details?.querySelector('.product-grid_atc-label');
        if ( response.error === true ) {
                    console.log( "Error encountered.");
                    //handleError()
                    live.textContent = `Unable to update cart.`;
                    if ( summary_label && details.matches(':has(.--pending)') ) {
                        summary_label.textContent = 'Updating Order';
                    }
                    const sidebar_items = document.querySelectorAll('.product-grid_minicart, .product-grid_shipping');
                    for( const sidebar_item of sidebar_items ) {
                        sidebar_item.inert = false;
                    }
                    return;
                }
                if (response.fragments) {
                    $.each(response.fragments, function(key, value) {
                        $(key).replaceWith(value);
                    });
                    $(document.body).trigger('wc_fragments_refreshed');
                }
                $(document.body).trigger("added_to_cart", [
                    response.fragments,
                    response.cart_hash,
                ]);

                cart_qty_input.value = qty;
                live.textContent = `${qty} ${legend.textContent} now in cart.`;

                // create a temporary message display

                input.classList.remove('--pending');
                if ( qty ) {
                    input.classList.add( '--in-cart' );
                } else {
                    input.classList.remove( '--in-cart' );
                }
                
                // update the summary label, based on if there are any sub-items remaining
                if ( summary_label && details.matches(':has(.--pending)') ) {
                    // could have multiple adding at once! wait until all resolve
                    summary_label.textContent = 'Updating Order';
                } else if ( summary_label && details.matches(':has(.--in-cart)') ) {
                    // if no pending and at least one added
                    summary_label.textContent = 'Added to Order';
                    const sidebar_items = document.querySelectorAll('.product-grid_minicart, .product-grid_shipping');
                    for( const sidebar_item of sidebar_items ) {
                        sidebar_item.inert = false;
                    }
                } else if ( summary_label ) { // no pending, no added
                    summary_label.textContent = 'Click to Order';
                    const sidebar_items = document.querySelectorAll('.product-grid_minicart, .product-grid_shipping');
                    for( const sidebar_item of sidebar_items ) {
                        sidebar_item.inert = false;
                    }
                }

                const header = document.querySelector('.kadence-sticky-header.item-hidden-above')
                if ( header ) {
                    header.style.transform = "translateY(" + 0 + "px)",
                    header.classList.remove("item-hidden-above")
                }
                input.dispatchEvent( new Event('qtychange', { bubbles: true } ) );
    }
    const control_sets = document.getElementsByClassName('product-grid_atc-controls');
    for( controls of control_sets ) {
        const minus = controls.querySelector('.product-grid_atc-minus');
        const plus = controls.querySelector('.product-grid_atc-plus');
        const input = controls.querySelector('.qty');
        const legend = controls.querySelector('.product-grid_atc-controls-legend');
        const live = controls.querySelector('.product-grid_atc-live');
        const add_to_cart = controls.querySelector('[name=add-to-cart]');
        const cart_qty_input = controls.querySelector('[name=cart-qty]:not([disabled])');

        minus.addEventListener( "click", () => changeQty( input, -1 ) )
        plus.addEventListener( "click", () => changeQty( input, 1 ) )

        const callback = debounce( updateCart, 400, false);
        input.addEventListener("input", () => callback(input, add_to_cart, cart_qty_input, live, legend) );
    }
    function changeQty( input, qty ) {
        let new_value = Number(input.value ?? 0) + qty;
        // let's clamp the value to a min and max
        if ( input?.max?.length) {
            new_value = Math.min(Math.max(new_value, Number(input?.min ?? 0 ) ), Number(input.max));
        }

        if ( Number(input.value) !== Number(new_value) ) {
            input.value = new_value
            input.dispatchEvent( new Event('input', { bubbles: true } ) );
        }
    }

    function updateCart(input, add_to_cart, cart_qty_input, live, legend) {
        // first make sure the number is properly clamped
        input.value = Math.min(Math.max(Number(input?.value ?? value), Number(input?.min ?? 0 ) ), Number(input.max));
        // use the api to update the cart
        const qty = Number(input?.value ?? 0);
        const id = add_to_cart.value;
        const data = {
            action: 'set_cart_qty',
            product_id: id,
            quantity: qty ?? 0,
        };

        // finnd the details and label
        const details = input.closest('.product-grid_atc');

        $.ajax({
            type: "POST",
            url: window.wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'set_cart_qty' ) ?? '/wp-admin/admin-ajax.php',
            data: data,
            beforeSend: function() {
                handlePending(qty, details, input, live, cart_qty_input, legend);
            },
            success: function (response) {
                handleResponse(qty, response, details, input, live, cart_qty_input, legend);
            },
            error: function () {
                // handle error gracefully?
            },
        });
        // $( document ).trigger( 'wc_update_cart' );
    }
    $(document.body).on('removed_from_cart', function(event, fragments, cart_hash, button) {
        
        console.log(event, fragments, cart_hash, button)
        const product_id = button?.[0]?.dataset?.product_id ?? null
        if ( product_id ) {
            // try to zero out item in the grid
            const atc_controls  = document.querySelectorAll(`.product-grid_atc-controls:has([value="${product_id}"])`)
            for ( const controls of atc_controls ) {
                const input = controls.querySelector('.qty');
                const legend = controls.querySelector('.product-grid_atc-controls-legend');
                const live = controls.querySelector('.product-grid_atc-live');
                const cart_qty_input = controls.querySelector('[name=cart-qty]:not([disabled])');
                const details = input.closest('.product-grid_atc');
                
                handleResponse(0, {}, details, input, live, cart_qty_input, legend);
                input.value = 0;
            }
        }
    } );
});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);
    if (callNow) func.apply(context, args);
  }
}